import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import CheckboxControl from '../../../lib/ui/CheckboxControl'
import CsvExporter from '../exporters/CsvExporter'

export default class ReportPeople {
  constructor (element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Personen rapportage',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      }]
    })

    let createReport = () => {
      if (!this.sendbirthdaycard.getValue() && 
      !this.sendbirthdayemail.getValue() &&
      !this.sendchristmascard.getValue() &&
       !this.sendchristmasemail.getValue()) {
        alert('Kies tenminste één optie.')
        return
      }

      window.PRIM.dataAccess.resolve('people').then((people) => {        
        let filtered = people.filter((person) => {
          return this.sendbirthdayemail.getValue() === true && person.values.sendbirthdayemail === true ||
          this.sendbirthdaycard.getValue() === true && person.values.sendbirthdaycard === true ||
          this.sendchristmasemail.getValue() === true && person.values.sendchristmasemail === true ||
          this.sendchristmascard.getValue() === true && person.values.sendchristmascard === true
        })

        if (filtered.length === 0) {
          alert('Er zijn geen personen die voldoen aan de gekozen opties.')
          return
        }

        let exporter = new CsvExporter()
        let csv = exporter.export(
          ['nickname', 'suffix', 'lastname', 'address', 'zipcode', 'city', 'country', 'email', 'phone', 'mobile'],
          filtered)
        let blob = new Blob([csv], {type: 'text/csv'})
        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, 'export.csv')
        } else {
          let url = URL.createObjectURL(blob)
          let tempAnchor = document.createElement('a')
          tempAnchor.href = url
          tempAnchor.download = 'export.csv'
          tempAnchor.className = 'invisible'
          document.body.appendChild(tempAnchor)
          tempAnchor.click()
          document.body.removeChild(tempAnchor)
          URL.revokeObjectURL(url)
        }
      }, (e) => {
        alert('Er is iets fout gegaan tijdens het maken van het rapport. Probeer het opnieuw.')
      })
    }

    let div = document.createElement('div')
    div.className = 'viewport'

    let fieldsetOptions = document.createElement('fieldset')
    let legendOptions = document.createElement('legend')
    legendOptions.innerHTML = 'Opties'
    fieldsetOptions.appendChild(legendOptions)

    this.sendbirthdayemail = new CheckboxControl(fieldsetOptions, {label: 'Verjaardagskaart per e-mail', readonly: window.PRIM.hasReadonlyModuleAccess('people')})
    this.sendbirthdaycard = new CheckboxControl(fieldsetOptions, {label: 'Verjaardagskaart per post', readonly: window.PRIM.hasReadonlyModuleAccess('people')})
    this.sendchristmasemail = new CheckboxControl(fieldsetOptions, {label: 'Kerstkaart per e-mail', readonly: window.PRIM.hasReadonlyModuleAccess('people')})
    this.sendchristmascard = new CheckboxControl(fieldsetOptions, {label: 'Kerstkaart per post', readonly: window.PRIM.hasReadonlyModuleAccess('people')})

    let button = document.createElement('button')
    button.innerHTML = 'Maak rapport'
    button.onclick = createReport

    div.appendChild(fieldsetOptions)

    div.appendChild(button)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/report/action/ReportPeople.js